import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PageHeader from '../../components/PageHeader/PageHeader';
import { Tabs, Tab } from '../../components/Tabs/Tabs';
import FilterCard from '../../components/FilterCard/FilterCard';
import Table from '../../components/Table/Table';
import Select from '../../components/Select/Select';
import { FaFileExcel, FaUser } from 'react-icons/fa';
import { BsInboxFill } from 'react-icons/bs';
import styles from './ProjelerListe.module.css';

const NoDataFound = () => (
  <div className="no-data-found">
    <BsInboxFill className="no-data-icon" />
    <h3 className="no-data-title">Gösterilecek Veri Bulunamadı</h3>
    <p className="no-data-text">
      Arama kriterlerinize uygun veri bulunmamaktadır. Lütfen filtrelerinizi değiştirerek tekrar deneyin.
    </p>
  </div>
);

const ProjelerListe = () => {
  const [activeTab, setActiveTab] = useState('proje-sayi-butce');
  const [searchTerm, setSearchTerm] = useState('');
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const [selectedFaculties, setSelectedFaculties] = useState([]);
  const [selectedDepartments, setSelectedDepartments] = useState([]);

  const facultyOptions = [
    { value: 'all', label: 'Tüm Fakülteler' },
    { value: 'muhendislik', label: 'Mühendislik Fakültesi' },
    { value: 'mimarlik', label: 'Mimarlık Fakültesi' },
    { value: 'fen', label: 'Fen Fakültesi' }
  ];

  const departmentOptions = [
    { value: 'all', label: 'Tüm Bölümler' },
    { value: 'endustri', label: 'Endüstri Mühendisliği' },
    { value: 'bilgisayar', label: 'Bilgisayar Mühendisliği' },
    { value: 'makine', label: 'Makine Mühendisliği' },
    { value: 'mimarlik', label: 'Mimarlık' },
    { value: 'sehir', label: 'Şehir ve Bölge Planlama' },
    { value: 'fizik', label: 'Fizik Mühendisliği' }
  ];

  const handleFacultyChange = (selectedOptions) => {
    setSelectedFaculties(selectedOptions);
    if (selectedOptions.some(option => option.value === 'all')) {
      setSelectedFaculties([{ value: 'all', label: 'Tüm Fakülteler' }]);
    }
  };

  const handleDepartmentChange = (selectedOptions) => {
    setSelectedDepartments(selectedOptions);
    if (selectedOptions.some(option => option.value === 'all')) {
      setSelectedDepartments([{ value: 'all', label: 'Tüm Bölümler' }]);
    }
  };

  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  const handleExcelExport = () => {
  };

  const navigate = useNavigate();

  const handleAkademisyenDetay = (akademisyen) => {
    navigate(`/akademisyen-detay/${akademisyen.id}`);
  };

  const columns = [
    { key: 'unvan', title: 'Ünvan', sortable: true },
    { key: 'adSoyad', title: 'Ad-Soyad', sortable: true },
    { key: 'fakulte', title: 'Fakülte', sortable: true },
    { key: 'bolum', title: 'Bölüm', sortable: true },
    { key: 'bapProjeSayisi', title: 'BAP Proje Sayısı', sortable: true },
    { key: 'bapProjeBütcesi', title: 'BAP Proje Bütçesi', sortable: true },
    { key: 'ttoProjeSayisi', title: 'TTO Proje Sayısı', sortable: true },
    { key: 'ttoProjeBütcesi', title: 'TTO Proje Bütçesi', sortable: true },
    { key: 'toplamProjeSayisi', title: 'Toplam Proje Sayısı', sortable: true },
    { key: 'toplamProjeBütcesi', title: 'Toplam Proje Bütçesi', sortable: true },
    { 
      key: 'actions',
      title: 'İşlemler',
      render: (row) => (
        <div className={styles.actionButtons}>
          <button
            className={styles.detailButton}
            onClick={() => {
              // navigate(`/akademisyen/${row.id}`);
              navigate(`/akademisyen/1`);
            }}
          >
            <FaUser />
            <span>Detay</span>
          </button>
        </div>
      )
    }
  ];

  const bapColumns = [
    { key: 'unvan', title: 'Ünvan', sortable: true },
    { key: 'adSoyad', title: 'Ad-Soyad', sortable: true },
    { key: 'destekleyenKurum', title: 'Destekleyen Kurum', sortable: true },
    { key: 'firma', title: 'Firma', sortable: true },
    { key: 'projeIsmi', title: 'Proje İsmi', sortable: true },
    { key: 'baslangic', title: 'Başlangıç', sortable: true },
    { key: 'bitis', title: 'Bitiş', sortable: true },
    { key: 'toplamProjeBütcesi', title: 'Toplam Proje Bütçesi', sortable: true },
    { key: 'durumu', title: 'Durumu', sortable: true }
  ];

  const ttoColumns = [
    { key: 'unvan', title: 'Ünvan', sortable: true },
    { key: 'adSoyad', title: 'Ad-Soyad', sortable: true },
    { key: 'destekleyenKurum', title: 'Destekleyen Kurum', sortable: true },
    { key: 'firma', title: 'Firma', sortable: true },
    { key: 'projeIsmi', title: 'Proje İsmi', sortable: true },
    { key: 'baslangic', title: 'Başlangıç', sortable: true },
    { key: 'bitis', title: 'Bitiş', sortable: true },
    { key: 'toplamProjeBütcesi', title: 'Toplam Proje Bütçesi', sortable: true },
    { key: 'durumu', title: 'Durumu', sortable: true }
  ];

  const donerSermayeColumns = [
    { key: 'unvan', title: 'Ünvan', sortable: true },
    { key: 'adSoyad', title: 'Ad-Soyad', sortable: true },
    { key: 'destekleyenKurum', title: 'Destekleyen Kurum', sortable: true },
    { key: 'firma', title: 'Firma', sortable: true },
    { key: 'projeIsmi', title: 'Proje İsmi', sortable: true },
    { key: 'baslangic', title: 'Başlangıç', sortable: true },
    { key: 'bitis', title: 'Bitiş', sortable: true },
    { key: 'toplamProjeBütcesi', title: 'Toplam Proje Bütçesi', sortable: true },
    { key: 'durumu', title: 'Durumu', sortable: true }
  ];

  const bapMockData = [
    {
      id: 1,
      unvan: "Prof. Dr.",
      adSoyad: "Mustafa Yanalak",
      destekleyenKurum: "TTO",
      projeIsmi: "Uydu Görüntü İzleme...",
      baslangic: "01.10.2024",
      bitis: "01.01.2025",
      toplamProjeBütcesi: "215.460.000,00 ₺",
      durumu: "Yürürlükte"
    },
    {
      id: 2,
      unvan: "Prof. Dr.",
      adSoyad: "Alim Rüstem Aslan",
      destekleyenKurum: "TTO",
      projeIsmi: "16 U Cubesat (1.5m GSD, 7-band Multi-Spectral Im...",
      baslangic: "23.06.2022",
      bitis: "01.03.2024",
      toplamProjeBütcesi: "57.882.534,00 ₺",
      durumu: "Yürürlükte"
    },
    {
      id: 3,
      unvan: "Prof. Dr.",
      adSoyad: "Berk Canberk",
      destekleyenKurum: "1773TTO",
      projeIsmi: "İTÜ-BTS Yapay Zeka Laboratuvarında Gerçekleşecek ...",
      baslangic: "15.09.2023",
      bitis: "15.09.2028",
      toplamProjeBütcesi: "29.687.060,00 ₺",
      durumu: "Yürürlükte"
    },
    {
      id: 4,
      unvan: "Doç. Dr.",
      adSoyad: "Tolga Görüm",
      destekleyenKurum: "1773TTO",
      projeIsmi: "Hava Lidar Verileri ile Enerji Nakil Hatlarının Ve...",
      baslangic: "01.01.2024",
      bitis: "01.01.2025",
      toplamProjeBütcesi: "21.520.000,00 ₺",
      durumu: "Yürürlükte"
    }
  ];

  const ttoMockData = [
    {
      unvan: "Prof. Dr.",
      adSoyad: "Mustafa Yanalak",
      destekleyenKurum: "TTO",
      firma: "Gizli",
      projeIsmi: "Uydu Görüntü İzleme...",
      baslangic: "01.10.2024",
      bitis: "01.01.2025",
      toplamProjeBütcesi: "215.460.000,00 ₺",
      durumu: "Yürürlükte"
    },
    {
      unvan: "Prof. Dr.",
      adSoyad: "Alim Rüstem Aslan",
      destekleyenKurum: "TTO",
      firma: "Office Of Research",
      projeIsmi: "16 U Cubesat (1.5m GSD, 7-band Multi-Spectral Im...",
      baslangic: "23.06.2022",
      bitis: "01.03.2024",
      toplamProjeBütcesi: "57.882.534,00 ₺",
      durumu: "Yürürlükte"
    },
    {
      unvan: "Prof. Dr.",
      adSoyad: "Berk Canberk",
      destekleyenKurum: "1773TTO",
      firma: "Bts Kurumsal Bilişim",
      projeIsmi: "İTÜ-BTS Yapay Zeka Laboratuvarında Gerçekleşecek ...",
      baslangic: "15.09.2023",
      bitis: "15.09.2028",
      toplamProjeBütcesi: "29.687.060,00 ₺",
      durumu: "Yürürlükte"
    },
    {
      unvan: "Doç. Dr.",
      adSoyad: "Tolga Görüm",
      destekleyenKurum: "1773TTO",
      firma: "Etiemtek",
      projeIsmi: "Hava Lidar Verileri ile Enerji Nakil Hatlarının Ve...",
      baslangic: "01.01.2024",
      bitis: "01.01.2025",
      toplamProjeBütcesi: "21.520.000,00 ₺",
      durumu: "Yürürlükte"
    }
  ];

  const donerSermayeMockData = [
    {
      unvan: "Prof. Dr.",
      adSoyad: "Hayrullah Güçlü İnsel",
      destekleyenKurum: "Döner Sermaye",
      firma: "Çevre Şehircilik ve İklim Değişikliği Bakanlığı",
      projeIsmi: "Çevre Yönetimi Genel Müdürlüğü Atıksu Arıtma Tesis...",
      baslangic: "16.10.2024",
      bitis: "19.11.2026",
      toplamProjeBütcesi: "24.272.222,00 ₺",
      durumu: "Yürürlükte"
    },
    {
      unvan: "Prof. Dr.",
      adSoyad: "Alper İlki",
      destekleyenKurum: "Döner Sermaye",
      firma: "Tüpraş",
      projeIsmi: "TÜPRAŞ Rafinerilerindeki Bina Tipi Yapıların Depre...",
      baslangic: "02.10.2023",
      bitis: "02.04.2024",
      toplamProjeBütcesi: "7.848.125,00 ₺",
      durumu: "Yürürlükte"
    },
    {
      unvan: "Prof. Dr.",
      adSoyad: "Hatice Ayataç",
      destekleyenKurum: "Döner Sermaye",
      firma: "İBB",
      projeIsmi: "İstanbul'un Deprem Sonrası Mekansal Yapı Gelişim...",
      baslangic: "15.08.2024",
      bitis: "15.08.2026",
      toplamProjeBütcesi: "6.000.000,00 ₺",
      durumu: "Yürürlükte"
    },
    {
      unvan: "Doç. Dr.",
      adSoyad: "Hüseyin Onur Tezcan",
      destekleyenKurum: "Döner Sermaye",
      firma: "İBB Ulaşım Dairesi B",
      projeIsmi: "İstanbul SUMP-İstanbul Sürdürülebilir Kentsel Hare...",
      baslangic: "01.09.2024",
      bitis: "01.09.2025",
      toplamProjeBütcesi: "4.406.400,00 ₺",
      durumu: "Yürürlükte"
    },
    {
      unvan: "Prof. Dr.",
      adSoyad: "Hatice Ayataç",
      destekleyenKurum: "Döner Sermaye",
      firma: "İBB",
      projeIsmi: "İstanbul'un Kentsel Kamusal Kıyı Alanlarında Doğal...",
      baslangic: "15.08.2023",
      bitis: "15.12.2024",
      toplamProjeBütcesi: "2.400.000,00 ₺",
      durumu: "Yürürlükte"
    }
  ];

  const mockData = [
    {
      id: 1,
      unvan: "Prof. Dr.",
      adSoyad: "Fatma Seniha Güner",
      fakulte: "Kimya-Metalurji Fakültesi",
      bolum: "Kimya Mühendisliği",
      bapProjeSayisi: 6,
      bapProjeBütcesi: "4.981.846,00 ₺",
      ttoProjeSayisi: 1,
      ttoProjeBütcesi: "75.000,00 ₺",
      toplamProjeSayisi: 7,
      toplamProjeBütcesi: "5.056.846,00 ₺"
    },
    {
      id: 2,
      unvan: "Doç. Dr.",
      adSoyad: "Mohammadreza Nofar",
      fakulte: "Kimya-Metalurji Fakültesi",
      bolum: "Metalurji ve Malzeme Mühendisliği",
      bapProjeSayisi: 7,
      bapProjeBütcesi: "1.164.982,00 ₺",
      ttoProjeSayisi: 0,
      ttoProjeBütcesi: "0,00 ₺",
      toplamProjeSayisi: 7,
      toplamProjeBütcesi: "1.164.982,00 ₺"
    }
  ];

  const getFilteredAndSortedData = (data) => {
    let filteredData = data;
    
    if (activeTab === 'proje-sayi-butce') {
      filteredData = mockData.filter(item => {
        const matchesSearch = Object.values(item).some(val => 
          val.toString().toLowerCase().includes(searchTerm.toLowerCase())
        );

        const matchesFaculty = selectedFaculties.length === 0 || 
          selectedFaculties.some(f => f.value === 'all') ||
          selectedFaculties.some(f => f.value === item.fakulte?.toLowerCase().replace(/\s+/g, ''));

        const matchesDepartment = selectedDepartments.length === 0 ||
          selectedDepartments.some(d => d.value === 'all') ||
          selectedDepartments.some(d => d.value === item.bolum?.toLowerCase().replace(/\s+/g, ''));

        return matchesSearch && matchesFaculty && matchesDepartment;
      });
    } else {
      filteredData = data.filter(item => {
        return Object.values(item).some(val => 
          val.toString().toLowerCase().includes(searchTerm.toLowerCase())
        );
      });
    }

    if (sortConfig.key) {
      filteredData.sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === 'asc' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === 'asc' ? 1 : -1;
        }
        return 0;
      });
    }

    return filteredData;
  };

  const renderFilters = () => (
    <FilterCard title="" className={styles.filterCard}>
      <FilterCard.Row className={styles.filterRow}>
        <FilterCard.Col className={`${styles.filterCol} text-end`}>
          <FilterCard.Button 
            className={`${styles.button} ${styles.buttonSuccess}`}
            variant="success"
            icon={<FaFileExcel />}
            onClick={handleExcelExport}
          >
            Excel'e Aktar
          </FilterCard.Button>
        </FilterCard.Col>
      </FilterCard.Row>
      
      <FilterCard.Row className={styles.filterRow}>
        <FilterCard.Col className={styles.filterCol}>
          <FilterCard.FormGroup label="Fakülte" className={styles.formGroup}>
            <Select
              options={facultyOptions}
              value={selectedFaculties}
              onChange={handleFacultyChange}
              placeholder="Fakülte seçin..."
            />
          </FilterCard.FormGroup>
        </FilterCard.Col>
        <FilterCard.Col className={styles.filterCol}>
          <FilterCard.FormGroup label="Bölüm" className={styles.formGroup}>
            <Select
              options={departmentOptions}
              value={selectedDepartments}
              onChange={handleDepartmentChange}
              placeholder="Bölüm seçin..."
            />
          </FilterCard.FormGroup>
        </FilterCard.Col>
      </FilterCard.Row>

      <FilterCard.Row className={styles['filter-row']}>
          <FilterCard.Col className={`${styles['filter-col']} ${styles['search-col']}`}>
            <FilterCard.SearchInput
              className={styles['search-input']}
              placeholder="Ad, soyad veya bölüm ara..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </FilterCard.Col>
      </FilterCard.Row>
    </FilterCard>
  );

  const renderTableContent = (data) => {
    let currentColumns;
    let currentData;

    switch (activeTab) {
      case 'bap-projeleri':
        currentColumns = bapColumns;
        currentData = bapMockData;
        break;
      case 'tto-projeleri':
        currentColumns = ttoColumns;
        currentData = ttoMockData;
        break;
      case 'doner-sermaye':
        currentColumns = donerSermayeColumns;
        currentData = donerSermayeMockData;
        break;
      default:
        currentColumns = columns;
        currentData = data;
    }

    const filteredData = getFilteredAndSortedData(currentData);
    
    if (filteredData.length === 0) {
      return <NoDataFound />;
    }

    return (
      <Table 
        columns={currentColumns}
        data={filteredData}
        onSort={handleSort}
        sortConfig={sortConfig}
      />
    );
  };

  return (
    <div className={styles.wrapper}>
      <PageHeader 
        title="Projeler Liste"
        description="Akademik performans göstergeleri ve istatistikler"
        breadcrumbs={[
          { text: 'Ana Sayfa', href: '/' },
          { text: 'Projeler', href: '/projeler' },
          { text: 'Projeler-Liste' }
        ]}
      />

      <div className={styles.headerStats}>
        <div className={styles.statsItem}>
          <span className={styles.statsLabel}>Toplam Proje (2024)</span>
          <span className={styles.statsValue}>1597</span>
          <span className={styles.statsBudget}>1.346.765.566,90 ₺</span>
        </div>
      </div>

      {renderFilters()}

      <div className={`${styles.card} ${styles.cardWrapper} project-list`}>
        <div className={styles.cardBody}>
          <Tabs activeTab={activeTab} onTabChange={setActiveTab}>
            <Tab id="proje-sayi-butce" title="Proje Sayı-Bütçe">
              {renderTableContent(mockData)}
            </Tab>
            <Tab id="bap-projeleri" title="BAP Projeleri">
              {renderTableContent(mockData)}
            </Tab>
            <Tab id="tto-projeleri" title="TTO Projeleri">
              {renderTableContent(mockData)}
            </Tab>
            <Tab id="doner-sermaye" title="Döner Sermaye">
              {renderTableContent(mockData)}
            </Tab>
          </Tabs>
        </div>
      </div>
    </div>
  );
};

export default ProjelerListe; 